const {
    REACT_APP_SOCKET_URL,
    REACT_APP_URL_SERVER_BFF
} = process.env;

export default {
    URL: REACT_APP_SOCKET_URL,
    TRANSPORTS: ["polling", "websocket"],
    PATH : `${REACT_APP_URL_SERVER_BFF}/socket.io`
}